import React from 'react';
import { classes, style } from 'typestyle';
import { colorBlack, colorBrand, colorSlate } from '../../theme/color';
import { styles } from './styles';
import { SVGIcon } from '../svg-icon';
import { ButtonPill } from '../button-pill';
import { LicenceSchema, TrackSchema } from '../../types/schema';
import { ImageModel } from '../../modules/image/model';
import { ArtistLinkList, InlineArtistLinkList } from '../artist-link-list';
import { AnalyticsController } from '../../modules/analytics/controller';
import { formatCurrency } from '../../lib/currency';
import copyrightIcon from '../../static/copyright.svg';
import timeIcon from '../../static/access_time.svg';
import mp3Icon from '../../static/mp3.svg';
import { resetAnchorStyles } from '../../theme/reset';
import { NestedCSSProperties } from 'typestyle/lib/types';
import CheckoutPlayButton from './checkout-play-button';
import ReactTooltip from 'react-tooltip';
import { px } from 'csx';
import { Badge } from '../badge';
import { shadowElevation2 } from '../../theme/shadow';

interface CheckoutTrackCardProps {
  model: { track: TrackSchema; price: string | number; currency: string };
  coverUrlProvider: ImageModel['cover'];
  onClickLink(event: React.MouseEvent<any>): void;
  onRemoveTrack(identity: string): void;
  handleEulaRequest: (track: TrackSchema) => void;
  handleRightsholderRequest: (track: TrackSchema) => void;
  analytics: AnalyticsController;
}

export default class CheckoutTrackCard extends React.Component<CheckoutTrackCardProps> {
  mp3IconRef: HTMLImageElement;

  timeIconRef: HTMLImageElement;

  render() {
    const {
      coverUrlProvider,
      model,
      onClickLink,
      onRemoveTrack,
      handleEulaRequest,
      handleRightsholderRequest,
      analytics,
    } = this.props;

    const { track, price, currency } = model;
    const { identity, images, artists } = track;

    const isUmg = track.reporting_party.slug === 'umg';

    return (
      <div className={styles.checkoutCard}>
        <div>
          <img className={styles.checkoutCardArtwork} src={coverUrlProvider(images.identity)} />
          <CheckoutPlayButton track={track} className={styles.checkoutCardPlay} />
          <div className={styles.checkoutCardArtist}>
            <p>
              <a href={`/music/artists/${track.artists[0].slug}/track/${track.slug}`} onClick={onClickLink}>
                {track.title}
              </a>
            </p>
            <p>{InlineArtistLinkList({ model: { artists }, onClickLink, analytics, linkClassName: 'artist' })}</p>
          </div>
        </div>
        <div>
          <div className={styles.checkoutCardRemove}>
            <ButtonPill tertiary icon onClick={() => onRemoveTrack(track.identity)} className={style(shadowElevation2)}>
              <SVGIcon.Cross size={16} color={colorBlack.toHexString()} />
            </ButtonPill>
            <span>Remove</span>
          </div>
          <div className={styles.checkoutCardArtistTotal}>
            <span className={classes(styles.totalText, styles.smallText)}>
              {track.basket.quantity} x {track.brand_sponsored ? 'Brand Sponsored' : 'Standard'} License
            </span>
            <span className={styles.totalText}>{formatCurrency(price, currency)}</span>
          </div>
        </div>
        <div>
          <ButtonPill tertiary onClick={() => handleEulaRequest(track)} className={styles.checkoutCardViewLicense}>
            View License
          </ButtonPill>
          <div className={styles.checkoutCardButtonBar}>
            <ButtonPill
              tertiary
              icon
              onClick={() => ReactTooltip.show(this.mp3IconRef)}
              className={style(shadowElevation2)}
            >
              <img src={mp3Icon} ref={(ref) => (this.mp3IconRef = ref)} data-tip=".mp3 file is included" />
            </ButtonPill>
            {isUmg && (
              <ButtonPill
                className={styles.checkoutCardButtonWithBadge}
                tertiary
                icon
                onClick={() => handleRightsholderRequest(track)}
              >
                <img src={copyrightIcon} />
                <Badge>1</Badge>
              </ButtonPill>
            )}
            {isUmg && (
              <ButtonPill
                tertiary
                icon
                onClick={() => ReactTooltip.show(this.timeIconRef)}
                className={style(shadowElevation2)}
              >
                <img
                  src={timeIcon}
                  ref={(ref) => (this.timeIconRef = ref)}
                  data-tip="The claims clearance process can take up to 48 hours for this type of license"
                />
              </ButtonPill>
            )}
          </div>
        </div>
        <ReactTooltip
          effect="solid"
          event="null"
          eventOff="mouseleave"
          delayHide={1000}
          place="left"
          className={styles.tooltip}
        />
      </div>
    );
  }
}
